/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 21 2023
 **/

import { usePersistActions } from "@/frameworks/core/persistence";

import * as APIs from "./private";

const LOGTAG = "#useMyDeskActions#";

export default function useMyDeskActions(events: API.Events = {}) {
	const { states } = usePersistActions();

	const show = () => {
		console.log(LOGTAG, "show");
		active(true);
	};

	const hide = () => {
		console.log(LOGTAG, "hide");
		active(false);
	};

	const active = (v: boolean) => {
		states.set_service_mode(v ? "MY_DESK" : "3D_SPACE");
	};

	return {
		//*
		...APIs.withMyDesk(events),
		...APIs.withMyDeskNotification(events),
		/*/
		...APIs.withMyDeskV2(events),
		...APIs.withMyDeskNotificationV2(events),
		//*/
		show,
		hide
	};
}
